import React from 'react';
import { Link } from 'react-router-dom';

/**
 * Parse a markdown-style link pattern in a plain-text string and return an
 * array of React nodes. Supports:
 *   [label](/internal-path)          → <Link to="/internal-path">
 *   [label](https://external.url)    → <a href target="_blank">
 *
 * Any other characters are returned as plain text nodes. This intentionally
 * supports ONLY [label](url) — no bold, italics, headings — so that article
 * bodies stay predictable and SEO-friendly (no HTML injection risk).
 */
export const renderInlineLinks = (text, keyPrefix = 'lnk') => {
  if (!text || typeof text !== 'string') return text;
  const RE = /\[([^\]]+)\]\(([^)]+)\)/g;
  const out = [];
  let lastIndex = 0;
  let m;
  let i = 0;
  while ((m = RE.exec(text)) !== null) {
    const [full, label, href] = m;
    if (m.index > lastIndex) out.push(text.slice(lastIndex, m.index));
    if (href.startsWith('/')) {
      out.push(
        <Link
          key={`${keyPrefix}-${i}`}
          to={href}
          className="text-[#0D4733] underline decoration-[#0D1520] underline-offset-2 hover:text-[#0D1520] hover:decoration-[#0D1520]"
        >
          {label}
        </Link>,
      );
    } else {
      out.push(
        <a
          key={`${keyPrefix}-${i}`}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#0D4733] underline decoration-[#0D1520] underline-offset-2 hover:text-[#0D1520] hover:decoration-[#0D1520]"
        >
          {label}
        </a>,
      );
    }
    lastIndex = m.index + full.length;
    i += 1;
  }
  if (lastIndex < text.length) out.push(text.slice(lastIndex));
  return out;
};
